export default __webpack_public_path__ + "static/media/16_Magic_Crystals.25ffc7d6.png";